import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1a237e' },
    secondary: { main: '#0d47a1' },
    background: { default: '#0a0e27', paper: '#131736' },
    text: { primary: '#e0e0e0', secondary: '#9e9e9e' },
    success: { main: '#4caf50' },
    warning: { main: '#ff9800' },
    error: { main: '#f44336' },
  },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", sans-serif',
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, border: '1px solid rgba(255,255,255,0.08)' }
      }
    }
  }
});
export default theme;
